<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { navigateTo } from 'yrv'
    
    
    import axios from 'axios'
    import wait from '../../libs/wait'
    
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import AdminLayout from '../../layouts/AdminLayout.svelte'
    import ClientItem from './ClientItem.svelte'
    import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
    import SidepanelContent from './ClientsSideContent.svelte'
    import CreateClient from './CreateClient.svelte'
    import VirtualList from '../../components/VirtualList/VirtualList.svelte'
    import userStore from '../../stores/user';
    
    import { height as windowHeight } from '../../stores/bounds'

    const dispatch = createEventDispatcher ();
    
    let screenReady = false,
        model       = null,
        searchQuery = '',
        create      = false;


    const onSearch = (event) => {
        searchQuery = event.detail;
        if (searchQuery.length > 1) {
            dispatch ('app-event', { id: 'background', value: true });
            axios.request ({
                method: 'post',
                url: '/api/clients/search',
                params: {
                    segment: searchQuery
                }
            }).then (result => {
                model = result.data.clients;
                dispatch ('app-event', { id: 'background', value: false });
                // console.log ('result', result.data)
            }).catch (e => {
                dispatch ('app-event', { id: 'background', value: false });
                dispatch ('app-event', { id: 'app-error', error: e });
            })
        } else
            fetchList ();
    }

    const onCreateClient = event => {
        create = true
    }

    const filterClients = list => {
        const clientsWhitelist = $userStore.clientsWhitelist.map(it => parseInt(it));
        // console.log ('clientsWhitelist', clientsWhitelist)
        return list.filter(it => {
            // console.log ('filter', it);
            if (clientsWhitelist.length === 0)
                return true;
            else
                return clientsWhitelist.includes(it.id);
        });
    }

    const onClientSave = event => {
        const { name } = event.detail
        const client_def = {"image":"","client_code":"","name":"","social_r":"","cf":"","piva":"","r_person":"","phone":"","email":"","info":"","address":[],"areas":[]}
        const client_req = {
            ...client_def,
            ...{
                name,
                social_r: name
            }
        }
        
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'post',
            url: '/api/clients/save',
            data: client_req
        }).then (result => {
            dispatch ('app-event', { id: 'background', value: false });
            dispatch ('app-event', { id: 'confirm', value: true });
            create = false;
            const payload = result.data.user;
            navigateTo (`/app/clients/${payload.id}/details`)
        })
    }

    const onClientCancel = event => {
        create = false
        console.log ('save cancel', event.detail)
    }

    const onDeleteClient = event => {
        const { id } = event.detail;
        console.log ('onDeleteClient', id)
        dispatch ('app-event', { id: 'background', value: true });
        axios.request ({
            method: 'post',
            url: '/api/clients/delete/?id=' + id
        }).then (result => {
            dispatch ('app-event', { id: 'confirm', value: true });
            fetchList ();
        })
    }

    const fetchList = () => {
        dispatch ('app-event', { id: 'background', value: true });
        screenReady = true
        axios.get ('/api/clients/all?filter=favorites')
            .then (result => {
                model = filterClients(result.data.clients);
                dispatch ('app-event', { id: 'background', value: false });
                setTimeout (() => {
                    screenReady = true
                }, 300)
            }).catch (e => {
                dispatch ('app-event', { id: 'app-error', error: e });
                screenReady = true    
            })
    }

    $: if ($userStore.clientsWhitelist) {
        fetchList()
    }
</script>


<Sidepanel>
    <SidepanelContent on:search={onSearch} on:create={onCreateClient} />
</Sidepanel>
<AdminLayout classes="sidepanel">
    <div class="ClientsList avoid-selection">
        {#if screenReady}
            <FadeinFX delay={300} delayOut={0}>
                <div class="clearfix">
                    {#if model}
                        <VirtualList items={model} height="{$windowHeight}px" let:item>
                            <ClientItem {item} on:delete={onDeleteClient} />
                        </VirtualList>
                    {/if}
                </div>
            </FadeinFX>
        {/if}
    </div>
</AdminLayout>

{#if create}
    <CreateClient on:save={onClientSave} on:cancel={onClientCancel} />
{/if}


<style>
    .ClientsList :global(svelte-virtual-list-viewport) {
        padding: 20px;
    }
</style>